export default {
  "about": {
    "careersDetails": {
      "anqing": "안칭",
      "applyResume": "이력서 제출",
      "backToPrevious": "이전 페이지로 돌아가기",
      "category": "카테고리:",
      "education": "최소 학력:",
      "errors": {
        "getInfoFailed": "정보 가져오기 실패",
        "getJobDetailFailed": "직무 상세 정보 가져오기 실패",
        "getJobDetailFailedRetry": "직무 상세 정보 가져오기 실패, 나중에 다시 시도해 주세요",
        "jobNotExist": "직무 정보가 존재하지 않습니다",
        "parseInfoFailed": "정보 분석 실패"
      },
      "jobDescription": "직무 설명",
      "jobRequirements": "자격 요건",
      "nationwide": "전국",
      "noJobInfo": "직무 정보가 존재하지 않습니다",
      "person": "명",
      "recruitmentCount": "채용 인원:",
      "salary": "급여 조건:",
      "suzhou": "수저우",
      "workLocation": "근무 지역:",
      "workYear": "경력 기간:"
    },
    "contact": {
      "address": "주소:",
      "contactInfo": "연락처",
      "email": "이메일:",
      "errors": {
        "getContactFailed": "연락처 데이터 가져오기 실패"
      },
      "pageTitle": "연락처",
      "phone": "전화:",
      "postcode": "우편번호:"
    },
    "page": {
      "careers": {
        "activities": {
          "balance": {
            "description": "일과 삶의 균형 유지",
            "subtitle": "균형 유지",
            "title": "균형 있는 발전"
          },
          "learning": {
            "description": "학습형 조직 구축, 평생 학습 추진",
            "subtitle": "계속 학습",
            "title": "학습은 끝이 없다"
          }
        },
        "category": "카테고리:",
        "errors": {
          "getAreaFailed": "근무 지역 가져오기 실패",
          "getAreaFailedRetry": "근무 지역 가져오기 실패, 나중에 다시 시도해 주세요",
          "getCategoryFailed": "직무 카테고리 가져오기 실패",
          "getCategoryFailedRetry": "직무 카테고리 가져오기 실패, 나중에 다시 시도해 주세요",
          "getJobsFailed": "직무 목록 가져오기 실패",
          "getJobsFailedRetry": "직무 목록 가져오기 실패, 나중에 다시 시도해 주세요",
          "getNatureFailed": "직무 성격 가져오기 실패",
          "getNatureFailedRetry": "직무 성격 가져오기 실패, 나중에 다시 시도해 주세요"
        },
        "jobCategory": "직무 카테고리",
        "jobNature": "직무 성격",
        "nationwide": "전국",
        "noData": "데이터 없음",
        "noJobs": "관련 직무 없음",
        "publishDate": "게시일",
        "searchBox": {
          "campusRecruitment": "신입 채용",
          "placeholder": "검색어를 입력하세요",
          "search": "검색",
          "socialRecruitment": "경력 채용"
        },
        "viewDetail": "상세 보기>",
        "workLocation": "근무 지역"
      },
      "company": {
        "companyIntro": "2003년 중국 쑤저우에 본사를 두고 설립되었으며, 여러 해에 걸친 혁신적 발전을 통해 이제는 연구 개발, 생산, 판매 및 서비스를 통합한 국가 고기술 기업으로 성장했습니다. 사업 범위는 생명 과학, 개인 위생, 신소재, 연구용 정선 제품, 검사 등을 포괴합니다。",
        "companyName": "야코 주식회사",
        "dataSection": {
          "founded": "설립",
          "globalCustomers": "글로벌 고객",
          "globalPartners": "글로벌 파트너",
          "patents": "국내외 특허 출원",
          "productionBase": "연간 생산 능력",
          "salesCountries": "판매 국가 및 지역",
          "title": "기업 데이터",
          "unit": "톤",
          "year": "년"
        },
        "history": {
          "title": "발전 과정"
        },
        "honor": {
          "title": "영예 및 자격"
        },
        "pageTitle": "회사 소개",
        "subtitle": "야코 주식회사는 글로벌 의약 화학 소재의 혁신 선도자입니다.",
        "vision": {
          "mission": {
            "description": "의약 화학 소재의 기술 발전과 혁신 추진",
            "title": "미션"
          },
          "title": "기업 이념",
          "values": {
            "description": "성실·감사, 책임·근면, 실무·투지, 혁신·탁월",
            "title": "핵심 가치"
          },
          "vision": {
            "description": "글로벌 의약 화학 소재 혁신 선도 기업으로 성장",
            "title": "비전"
          }
        }
      },
      "production": {
        "intro": "야코 주식회사는 안정적인 제조 능력을 보유하고 있습니다. 현재 지닝과 안칭에 두 개의 생산 기지를 건설했으며 국제적으로 선진적인 생산 설비와 생산 기술을 갖추고 고품질의 정밀 화학 제품 연구 개발 및 생산에 전념하고 있습니다. 단일 기지의 총 생산 능력은 10만 톤을 초과하며 ISO9001 품질 관리 시스템, ISO14001 환경 관리 시스템, ISO45001 직업 건강 안전 관리 시스템 인증을 획득했습니다.",
        "intro2": "야코 주식회사는 '제로 결함' 품질 관리 시스템을 통해 모든 제품이 업계의 높은 기준에 도달하도록 보장하며, 글로벌 고객에게 안정적이고 신뢰할 수 있는 화학 제품 공급 솔루션을 지속적으로 제공하고 있습니다. 규모화된 생산 능력, 스마트 생산, 원료 전 과정 관리의 경쟁 우위를 바탕으로 의료 건강, 바이오 테크놀로지 등의 전략적 신흥 산업에 '과학 연구에서 상업화 생산까지'의 원스톱 원료 솔루션을 제공하며 고객의 안정적인 발전을 지원하고 있습니다.",
        "siteInfo": {
          "area": "부지 규모:",
          "capacity": "공장 및 생산 능력:",
          "coreProducts": "핵심 제품:",
          "field": "응용 분야:"
        },
        "title": "생산 기지"
      },
      "quality": {
        "equipment": {
          "description": "고성능 액체 크로마토그래피 장비, 가스 크로마토그래피 장비, 핵자기 공명 장비, 편광계, 적외선 분광기, 유도 결합 플라즈마 발광 분광 분석기, 자동 전위 적정 장비, 칼 피셔 수분 측정기 등의 포괄적인 검사 장비 플랫폼을 구축함으로써 야코 주식회사는 고객의 다양한 시나리오에서 고정밀도이고 복잡한 검사 요구를 충족시킬 수 있습니다.",
          "devices": {
            "automaticTitrator": "자동 전위 적정 장비",
            "broadbandNMR": "광대역 다중 코일 핵자기 공명 장비",
            "gcms": "GC-MS",
            "icpSpectrometer": "유도 결합 플라즈마 발광 분광 분석기",
            "infraredSpectrometer": "적외선 분광기",
            "karlFischer": "칼 피셔 수분 측정기"
          },
          "title": "검사 장비"
        },
        "intro": "야코 주식회사는 공정 관리를 통해 제품 품질을 보장하며, 고객에게 더 나은 가성비의 다양한 제품과 우수한 서비스를 제공하고 고객의 혁신을 지원하는 것을 사명으로 삼고 있습니다. 야코 주식회사의 의약 화학 소재 분야에서의 22년간의 검사 경험을 바탕으로 박사 학위를 보유한 연구 분석 팀이 이끌며, 고객에게 검사에서 기술 최적화까지의 원스톱 솔루션을 제공합니다.",
        "intro2": "야코 주식회사의 검사 플랫폼은 3000㎡의 현대적인 실험실을 보유하며 국내 최고 수준의 공기 순환 및 정화 시스템을 구축하여 검사 환경의 안전성과 관리를 보장합니다. 플랫폼에는 포괄적인 화학 분석 공간과 최고급 장비가 구비되어 있어 고정밀도이고 복잡한 검사 요구를 충족할 수 있습니다. 각국/지역의 법률 규정 및 기술 표준(예: EU REACH, 미국 FDA, 중국 CDE 등)에 따라 고객이 무역 장벽을 피하고 제품 수명 주기 전반에 걸친 규정 준수 관리를 실현할 수 있도록 지원합니다.",
        "navigation": {
          "next": "다음",
          "prev": "이전"
        },
        "system": {
          "description": "야코 주식회사는 구조 특성, 물리화학적 특성, 원소 분석, 스펙트럼 분석, 안정성 연구, 데이터 완전성 및 추적 가능성, 불순물 분석 연구, 원료 검사 등을 포함하는 포괄적인 의약 화학 소재 검사 시스템을 확립했으며, 품질 관리는 GMP 시스템, ISO9001:2015 품질 관리 시스템 인증을 획득하여 고객의 글로벌 시장에서의 개발과 응용을 지원합니다.",
          "title": "검사 시스템"
        },
        "title": "품질 관리"
      }
    },
    "tabs": {
      "careers": "채용 정보",
      "company": "회사 소개",
      "production": "생산 기지",
      "quality": "품질 관리"
    }
  },
  "dzhc": {
    "businessIntroText": "맞춤형 서비스는 야코 주식회사의 핵심 사업입니다. 의약 화학 소재 분야에서의 22년간의 연구 개발 경험을 바탕으로 야코 주식회사는 고객에게 신뢰할 수 있는 원스톱 맞춤형 서비스를 제공할 수 있습니다. 우리는 경험 많은 과학자와 엔지니어로 구성된 연구 개발 팀과 품질 검사 팀을 보유하고 있으며, AI 지능형 합성 플랫폼, 화학 합성 플랫폼, 생물 합성 플랫폼 등의 5개 실험 플랫폼을 구축하고 고성능 액체 크로마토그래피 장비, 가스 크로마토그래피 장비, 편광계 등의 선진적인 검사 플랫폼을 갖추고 있습니다. 또한 야코 주식회사는 연간 생산 능력이 10만 톤을 초과하는 2개의 생산 기지를 보유하고 있어 의약 화학 소재 분야 고객의 맞춤 합성, CRO 서비스부터 CDMO 서비스까지의 전 과정 요구를 충족할 수 있습니다.",
    "businessIntroTitle": "사업 개요",
    "businessItems": ["고분자 소재", "폴리머 단량체", "의약 중간체", "전자 화학 신소재", "임상 검사 원료"],
    "caseTabs": [
      {
        "title": "의약 화학 분야 전문가 팀",
        "description": "100명 가까운 경험 많은 과학자와 엔지니어로 구성되어 있으며, 석사·박사 전문 인력이 40% 이상이고 연구 개발 특허 출원이 150건 이상이며 승인된 것이 50건 이상입니다."
      },
      {
        "title": "최고 수준의 연구 개발 및 검사 플랫폼",
        "description": "AI 지능형 합성 플랫폼, 화학 합성 플랫폼, 생물 합성 플랫폼 등의 5개 실험 플랫폼을 구축하고 고성능 액체 크로마토그래피 장비, 가스 크로마토그래피 장비, 편광계 등의 선진적인 검사 플랫폼을 갖추고 있습니다."
      },
      {
        "title": "국제 품질 시스템 보증",
        "description": "ISO 국제 표준을 엄격히 준수하며 전 과정 품질 관리를 통해 제품의 높은 신뢰성을 보장합니다. 원료 선별부터 완제품까지 다층 검사 포인트와 전 과정 품질 관리를 실시합니다."
      }
    ],
    "coreBusinessTitle": "핵심 사업",
    "featureTitle": "서비스 특징",
    "pageSubtitle": "의약 제품 CRO+CDMO 맞춤 서비스",
    "pageTitle": "맞춤형 서비스",
    "processItems": [
      {
        "title": "경로 설계",
        "desc": ["100명 이상의 경험 많은 연구 개발자", "AI 지원 합성 경로 설계"]
      },
      {
        "title": "연구 개발 합성",
        "desc": ["10,000㎡ 이상의 연구 개발 실험실", "80% 이상의 일반적인 반응 커버리지"]
      },
      {
        "title": "시료 생산",
        "desc": ["200,000㎡ 이상의 공장 생산", "엄격한 품질 관리, 품질 보증"]
      },
      {
        "title": "분장 및 발송",
        "desc": ["각종 고체/액체 분장 발송 요구 충족", "전문적인 시료 발송/물류 추적"]
      }
    ],
    "processTitle": "맞춤 합성 프로세스",
    "startProject": "지금 바로 맞춤 프로젝트 시작",
    "startProjectDesc": "요구 사항을 알려주시면 전문 팀이 1:1 기술 상담과 맞춤형 솔루션을 제공합니다.",
    "viewMore": "더 보기"
  },
  "header": {
    "contactUs": "연락처",
    "menu": {
      "about": "야코 소개",
      "companyProfile": "회사 소개",
      "customSynthesis": "맞춤형 서비스",
      "greenEnergy": "그린 에너지",
      "innovation": "혁신 성과",
      "joinUs": "채용 정보",
      "news": "뉴스 센터",
      "other": "기타 사업",
      "production": "생산 기지",
      "products": "제품 센터",
      "quality": "품질 관리",
      "rAndDSystem": "연구 개발 시스템",
      "researchPurchase": "연구 구매",
      "smartPlatform": "지능형 플랫폼",
      "solution": "산업 솔루션",
      "sustainability": "지속 가능한 발전",
      "technology": "연구 개발 혁신",
      "testingService": "검사 서비스"
    },
    "searchPlaceholder": "검색 내용 입력..."
  },
  "home": {
    "about": {
      "description": "2003년 중국 쑤저우에 본사를 두고 설립되었으며, 여러 해에 걸친 혁신적 발전을 통해 이제는 연구 개발, 생산, 판매 및 서비스를 통합한 국가 고기술 기업으로 성장했습니다. 사업 범위는 생명 과학, 개인 위생, 신소재, 연구용 정선 제품, 검사 등을 포괴합니다。",
      "learnMore": "더 알아보기",
      "subtitle": "야코 주식회사는 글로벌 의약 화학 소재의 혁신 선도자입니다.",
      "title": "야코 소개"
    },
    "globalService": {
      "description": "야코 주식회사는 글로벌 고객에게 맞춤 합성부터 규모 생산까지의 원스톱 CRO+CMO 서비스를 제공하며, 과학 연구에서 상업화 생산까지의 전 과정 제품 요구를 충족할 수 있습니다.",
      "legend": {
        "customers": {
          "en": "Our Customers",
          "zh": "서비스 고객"
        },
        "headquarters": {
          "en": "Yacoo Headquarter",
          "zh": "야코 본사"
        },
        "subsidiaries": {
          "en": "Subsidiary Companies",
          "zh": "야코 자회사"
        }
      },
      "stats": {
        "title": "해외 진출",
        "capacity": "싱가포르, 미국, 독일에 해외 자회사 설립",
        "patents": "글로벌 고객 수 15,000개 이상",
        "team": "70개 이상의 국가에서 사업 운영"
      },
      "title": "글로벌 서비스 네트워크"
    },
    "news": {
      "noNews": "관련 뉴스 없음",
      "pageTitle": "뉴스 센터",
      "searchPlaceholder": "검색어 입력",
      "title": "야코 동향",
      "topTag": "상단 고정",
      "viewDetail": "자세히 보기",
      "viewMore": "더 보기"
    },
    "solutions": {
      "title": "제품 및 솔루션"
    }
  },
  "jcfw": {
    "actionBtn": "지금 상담",
    "businessIntroText1": "완더 테스팅(Wonder Testing)은 야코 주식회사 산하의 독립적인 검사 서비스 플랫폼입니다. 야코 주식회사의 의약 화학 소재 분야에서의 22년간의 검사 경험을 바탕으로, 완더 테스팅은 국제적인 품질 서비스 플랫폼 구축에 힘쓰고 있으며, CMA 자격 인증(중국 계량 인증)과 CNAS 실험실 인증(ISO/IEC17025)에 따라 국내/외 제조 기업/무역 회사에 각종(각국/지역) 법률/규정/기술 표준의 검사 서비스, 인증 및 해당 컨설팅 서비스를 제공합니다. 고객에게 검사에서 기술 최적화까지의 원스톱 솔루션을 제공합니다.",
    "businessIntroText2": "완더 테스팅 플랫폼은 3000㎡의 현대적인 실험실을 보유하며 국내 최고 수준의 공기 순환 및 정화 시스템을 구축하여 검사 환경의 안전성과 관리를 보장합니다. 플랫폼에는 포괄적인 화학 분석 공간과 최고급 장비가 구비되어 있어 고정밀도이고 복잡한 검사 요구를 충족할 수 있습니다. 각국/지역의 법률 규정 및 기술 표준(예: EU REACH, 미국 FDA, 중국 CDE 등)에 따라 고객이 무역 장벽을 피하고 제품 수명 주기 전반에 걸친 규정 준수 관리를 실현할 수 있도록 지원합니다.",
    "businessIntroTitle": "사업 개요",
    "businessItems": ["검사 서비스", "의학 연구 및 시험 개발", "검사 기술 서비스", "인증 서비스"],
    "businessItemsClass": ["일상 소비재", "전자 전기 제품", "장난감 및 아동용품", "식품 접촉 재료", "자동차 재료", "경공업 제품 및 섬유 제품"],
    "businessTip": "실험실은 포괄적인 검사 서비스 시스템을 확립하여 일상 소비재, 전자 전기 제품, 장난감 및 아동용품, 식품 접촉 재료, 자동차 재료, 경공업 제품 및 섬유 제품 등의 화학적 및 물리적 검사 요구를 충족할 수 있습니다.",
    "caseTabs": [
      {
        "title": "규정 준수 검사 인증 경험",
        "description": "실험실은 야코 주식회사의 의약 분야에서의 22년간의 검사 서비스 경험을 바탕으로 글로벌 제조 기업 및 무역업자에게 규정 준수 검사, 인증 및 기술 컨설팅 서비스를 제공하는 데 힘쓰고 있습니다."
      },
      {
        "title": "국제 표준 관리 시스템 인증",
        "description": "검사 지표와 관리 시스템은 국제 품질 시스템 요구 사항을 준수하며 많은 국제적인 주요 고객의 승인을 받아 검사 데이터의 권위성과 신뢰성을 보장합니다."
      },
      {
        "title": "검사 능력 포괄적 커버리지",
        "description": "소비재 화학 검사, 아동 장난감 안전 평가, 섬유 제품 검사, 식품 접촉 재료 규정 준수 검사, 자동차 재료 분석 등의 분야의 포괄적인 서비스를 제공하며 기업이 각국의 규정 요구 사항(REACH, FDA, CDE 등)에 대응할 수 있도록 지원합니다."
      }
    ],
    "contact": {
      "address": "주소:수저우 산업 단지 신칭로 112호 8층",
      "email": "연락 이메일:service@wondertesting.cn",
      "phone": "전화:+86-18625246998",
      "postcode": "우편번호:215121"
    },
    "contactTitle": "연락처",
    "coreBusinessTitle": "핵심 사업",
    "equipmentDesc": "고성능 액체 크로마토그래피 장비, 가스 크로마토그래피 장비, 핵자기 공명 장비, 편광계, 적외선 분광기 등의 포괄적인 검사 장비 플랫폼을 구축함으로써 야코 주식회사는 고객의 다양한 시나리오에서 고정밀도이고 복잡한 검사 요구를 충족시킬 수 있습니다.",
    "equipmentList": ["적외선 분광기", "광대역 다중 코일 핵자기 공명 장비", "유도 결합 플라즈마 발광 분광 분석기", "칼 피셔 수분 측정기", "GC-MS", "자동 전위 적정 장비"],
    "equipmentTitle": "검사 장비",
    "featureTitle": "서비스 특징",
    "nextBtn": "다음",
    "pageSubtitle": "독립 검사에서 기술 최적화까지의 통합 서비스 제공자",
    "pageTitle": "검사 서비스",
    "platformDesc": "검사 인증 통합 서비스 제공자",
    "prevBtn": "이전",
    "shopSubtitle": "독립 검사에서 기술 최적화까지의 통합 서비스 제공자",
    "shopTitle": "완더 테스팅",
    "viewMore": "더 보기"
  },
        "kycg": {
          "actionBtn": "솔루션 받기",
          "businessIntroText": "엘리멘트 쇼핑몰(www.b2star.com)은 야코 주식회사 산하의 전문적인 연구용품 원스톱 구매 전자상거래 플랫폼입니다. 국내외 우수 브랜드 공급업체 채널을 통합하여 전문적인 연구용 시약, 보호 장비, 생물 소모품, 실험 장비 등의 관련 제품을 제공하며 국내외 생명 과학 연구, 바이오 의약품 및 신소재 분야 고객의 다양한 요구를 더 잘 충족시키기 위해 노력하고 있습니다.",
          "businessIntroTitle": "사업 개요",
          "businessItems": [
            {
              "title": "연구용 시약",
              "desc": "생물 시약, 화학 시약, 분석 시약, 기타 시약"
            },
            {
              "title": "보호 장비",
              "desc": "손 보호, 머리 보호, 얼굴 보호, 기타 보호"
            },
            {
              "title": "생물 소모품",
              "desc": "세포 배양, 의료용 소모품, 크로마토그래피 소모품, 검사 소모품, 피펫팅 소모품, 도구류 소모품"
            },
            {
              "title": "실험 장비",
              "desc": "일반 장비, 검사 장비, 크로마토그래피 장비, 특수 장비, 안전 시설"
            }
          ],
          "caseTabs": [
            {
              "title": "24시간 배송 응대",
              "description": "다중 창고 직송, 신속 배송"
            },
            {
              "title": "600만+ 규격 제품",
              "description": "다양한 브랜드, 풍부한 품목"
            },
            {
              "title": "600+ 유명 협력 브랜드",
              "description": "제조사 공식 인증, 정품 보증"
            },
            {
              "title": "친절한 구매 서비스",
              "description": "다양한 혜택, 전문 서비스"
            }
          ],
          "contact": {
            "addressSuqian": "주소(수첸): 수이첸시 수이첸 디지털 경제 센터 B3동 1201호",
            "addressSuzhou": "주소(수저우): 수저우시 산업단지 신칭로 112호",
            "addressWuhan": "주소(우한): 우한 동호 신기술 개발구 고신대로 766호 광곡 본부 센터 T3동 11층 07호",
            "addressChengdu": "주소(청두): 청두시 무후구 우커시일루 딩성 국제 3동 706호",
            "email": "이메일: sxg@b2star.com",
            "phone": "전화: 15335295587"
          },
          "contactTitle": "연락처",
          "coreBusinessTitle": "핵심 사업",
          "enterShop": "주문하기",
          "featureTitle": "서비스 특징",
          "pageSubtitle": "연구 구매 원스톱 플랫폼",
          "pageTitle": "연구 구매",
          "shopBusiness": ["연구용 시약", "안전 보호", "생물 소모품", "실험 장비"],
          "shopSubtitle": "연구 구매 원스톱 플랫폼",
          "shopTitle": "엘리멘트 쇼핑몰"
        },
        "lsny": {
          "actionBtn": "샘플 받기",
          "businessIntroText": "구디나 신에너지(www.goodenoughchem.com)는 야코 주식회사 산하의 그린 에너지 서비스 플랫폼입니다. 자체 개발한 난연성 원위치 경화제는 배터리 안전성을 효과적으로 향상시켜 많은 주요 기업의 협력 인증을 받았습니다. 신에너지 리튬 배터리 재료 통합 서비스 제공자로서, 구디나 신에너지는 연구 요구부터 규모 생산까지의 전방위 요구를 충족하며 기본 전해액 구성, 전해액 원재료 및 특수 기능 전해액, 전문 대량 전해액 구성/전해액 맞춤 서비스를 제공할 수 있습니다.",
          "businessIntroTitle": "사업 개요",
          "businessItems": [
            {
              "title": "전해액"
            },
            {
              "title": "화학 시약"
            },
            {
              "title": "배터리 재료"
            },
            {
              "title": "특수 기능 전해액"
            }
          ],
          "caseTabs": [
            {
              "title": "제품 매트릭스 풍부",
              "description": "100여 종의 신에너지 리튬 배터리 기능 첨가제 개발 완료, 리튬/나트륨/마그네슘/알루미늄 전해액 제공 가능"
            },
            {
              "title": "연구 개발 맞춤부터 대량 생산까지",
              "description": "10종 이상의 리튬 배터리 기능 재료의 산업화 능력 보유, 그 중 에톡시포스파젠 계열 제품은 100톤 규모 생산 능력 계획"
            },
            {
              "title": "주요 기업 협력 인증",
              "description": "고체 난연제 제품 지표는 국제 수준에 도달, 국내 많은 주요 신에너지 기업의 인증 획득"
            }
          ],
          "contactAddress": "주소: 수저우 산업 단지 신칭로 112호 8층",
          "contactEmail": "이메일: sales022@b2star.com",
          "contactPhone": "전화: 18136447806",
          "contactPostcode": "우편번호: 215121",
          "contactQQ": "QQ: 693755679",
          "contactSubtitle": "신에너지 리튬 배터리 재료 통합 서비스 제공자",
          "contactTitle": "연락처",
          "coreBusinessTitle": "핵심 사업",
          "enterShop": "더 알아보기",
          "featureTitle": "서비스 특징",
          "pageSubtitle": "신에너지 리튬 배터리 재료 통합 서비스 제공자",
          "pageTitle": "그린 에너지",
          "shopSubtitle": "신에너지 리튬 배터리 재료 통합 서비스 제공자",
          "shopTitle": "구디나 신에너지"
        },
        "news": {
          "searchBtn": "검색",
          "filter": "뉴스 카테고리를 선별하다",
          "noNews": "관련 뉴스 없음",
          "pageTitle": "뉴스 센터",
          "searchPlaceholder": "검색어 입력",
          "title": "야코 동향",
          "topTag": "상단 고정",
          "viewDetail": "자세히 보기",
          "viewMore": "더 보기"
        },
        "products": {
          "centerTitle": "제품 센터",
          "screening": "제품 종류를 선별하다",
          "detail": {
            "advantages": "서비스 장점",
            "batchInquiry": "대량 구매 견적 요청",
            "breadcrumbCenter": "제품 센터",
            "breadcrumbHome": "홈",
            "cas": "CAS 번호: {cas}",
            "customSynthesis": "맞춤 합성 문의",
            "featured": "인기 제품 추천",
            "features": "제품 특징",
            "getSample": "샘플 요청",
            "noData": "데이터 없음",
            "notes": "비고",
            "related": "관련 제품 추천",
            "researchPurchase": "연구 구매"
          },
          "mainProducts": "주요 제품",
          "noData": "데이터 없음",
          "searchBtn": "검색",
          "searchPlaceholder": "제품명, 품번, CAS 번호 또는 키워드 입력",
          "panel": {
            "EnglishName": "영문명",
            "Name": "제품명",
            "Alias": "별칭",
            "CAS": "CAS 번호",
            "UsagePlatform": "응용 플랫폼",
            "ArtNo": "품번",
            "molecularFormula": "분자식",
            "molecularWeight": "분자량",
            "ec": "EC 번호",
            "enzymeActivity": "효소 활성",
            "activity": "활성"
          }
        },
        "solution": {
          "learnMore": "더 알아보기",
          "pageSubtitle": "의약 화학 소재의 기술 발전과 혁신 추진",
          "pageTip": "야코 주식회사는 항상 의약 화학 소재의 기술 발전과 혁신에 집중하며, 기술 혁신과 안정적인 공급을 바탕으로 고객의 전문적인 요구를 충족시키고, 고품질이면서 편리하고 가성비 좋은 다양한 제품과 서비스를 제공하며, 의약 화학 소재 산업의 지속적인 발전을 추진하고, 녹색 건강한 미래를 함께 건설합니다.",
          "pageTitle": "산업 솔루션",
          "tableName": "명칭"
        },
        "sustainability": {
          "conceptText": "야코 주식회사는 지속 가능한 발전 이념을 항상 견지하며, 녹색 혁신을 연구 개발, 생산 및 운영의 전 과정에 통합하고 있습니다. 우리는 환경 보호 공정 최적화, 자원 순환 이용 및 청정 에너지 응용을 통해 탄소 발자국을 줄이기 위해 노력하고 있습니다. 기술 혁신을 통해 생분해성 소재와 녹색 솔루션 개발을 추진하며, 업계의 저탄소 전환을 지원합니다. 동시에, 우리는 적극적으로 사회적 책임을 실천하며, 직원, 지역 사회 및 환경과의 공생 공영 시스템을 구축하고, 경제적 이익, 생태적 이익 및 사회적 이익의 조화로운 발전을 추구하며, 글로벌 지속 가능한 발전 목표에 기여합니다.",
          "conceptTitle": "지속 가능한 발전 이념",
          "dataSection": {
            "highConcentrationGas": "녹색 전력 사용 비율",
            "lowConcentrationGas": "이산화탄소 환산량/백만 위안",
            "solidWasteStorage": "신장 케저우 2중 도서 기증",
            "wastewaterTreatment": "2024년 사회 기부금",
            "units": {
              "cubicMeterPerHour": "%",
              "ton": "톤",
              "tonPerDay": "권",
              "yuan": "위안"
            }
          },
          "environmentalProtection": {
            "altText": "환경 보호",
            "description": "야코 주식회사는 국가 및 지방의 환경 보호 관련 법률 규정 및 기타 관련 규정을 엄격히 준수하며, ISO14001 환경 관리 시스템 인증을 획득했습니다. 완비한 삼폐 처리 시설을 보유하며, 선진적인 폐수, 폐기물 가스 및 고체 폐기물 처리 시설을 도입함으로써 환경 친화적인 전제 하에서 안전하게 생산 활동을 전개할 수 있습니다.",
            "title": "환경 보호"
          },
          "greenDevelopment": {
            "buildingAlt": "야코 주식회사 본사 건물",
            "description": "\"의약 화학의 경계를 넘어, 녹색 미래를 함께 창조한다\"는 기업의 초심을 견지하며, 야코 주식회사는 인프라 건설에서 제품 개발에 이르기까지 항상 녹색 발전을 사명으로 삼고 있습니다. 그룹 본사 건물은 미국 그린 빌딩 협회에서 수여하는 LEED(에너지 및 환경 설계 선도) 플래티넘 인증을 획득했으며, 태양광 패널 등의 녹색 전력 설비로 에너지 공급을 실현하고 있습니다. 야코 주식회사는 재생 가능한 농작물에서 생산되는 바이오 기반 신소재 폴리2,5-푸란디카르복실산 에틸렌글리콜(PEF)을 기반으로 하며, 병용 분야에 광범위하게 응용 가능하여 제품 생산 과정 전반의 탄소 발자국을 현저히 줄일 수 있습니다.",
            "title": "녹색 발전"
          },
          "pageSubtitle": "의약 제품 CRO+CDMO 맞춤 서비스",
          "pageTitle": "지속 가능한 발전",
          "safetyProduction": {
            "certificateAlt": "환경 인증서",
            "description": "야코는 ISO45001 직업 건강 안전 관리 시스템 요구 사항을 참조하여 완비한 안전 생산 관리 시스템을 수립했습니다. 정보화 및 지능화 설비를 통해 안전 생명선을 지킵니다. 야코 안칭 생산 기지를 예로 들면, 이 기지는 생산 안전 표준화 3급 인증을 획득했으며, 안전 생산 정보화 시스템을 구축하여 인원 위치 확인, 지능형 순찰 검사, 이중 예방 등의 오위일체 안전 위험 방지 관리 시스템을 실현했습니다.",
            "title": "안전 생산"
          }
        },
        "technology": {
          "achievementsTitle": "혁신 성과",
          "businessIntroText": "야코 주식회사는 10,000㎡ 이상의 연구 개발 센터를 보유하며, AI 합성 플랫폼, 미세 채널 연속류 반응기 등의 첨단 설비를 갖추고, 석사·박사 학위를 보유한 100여 명의 연구 개발 팀을 구성하고 있습니다. 중국과학원 닝보 소재 연구소, 수저우 대학 등 고등 교육 기관과의 깊은 산학연 협력을 통해 \"장쑤성 공정 기술 연구 센터\", \"JITRI-야코 공동 혁신 센터\" 등의 혁신 플랫폼을 설립했으며, 완비한 연구 개발 및 성과 전환 시스템을 형성했습니다. 현재까지 기업은 150건 이상의 특허를 출원했습니다.",
          "businessIntroTitle": "완비한 연구 개발 시스템",
          "businessItems": [
            {
              "title": "생물 의학 정화제 및 구조성 화학 제품"
            },
            {
              "title": "고급 체외 진단 시약 개발"
            },
            {
              "title": "생물 효소 개발"
            },
            {
              "title": "고급 생물 고분자 소재 개발"
            },
            {
              "title": "반도체 등급 전자 화학 제품 및 신에너지 배터리 재료"
            }
          ],
          "consultBtn": "맞춤 상담",
          "customServiceDesc": "의약 화학 소재 분야에서의 22년간의 연구 개발 경험을 바탕으로, 야코 주식회사는 고객에게 신뢰할 수 있는 맞춤 합성 서비스를 제공할 수 있습니다.",
          "customServiceTitle": "그램 단위부터 톤 단위까지의 맞춤 서비스",
          "leadingProcess": "선도적 공정",
          "pageTitle": "지능 주도 기술 미래 창조",
          "platformList": [
            {
              "title": "AI 지능형 실험실",
              "description": "AI 지능형 합성 실험실은 AI 지능형 합성 장비를 갖추고 있어 반응 단계와 매개변수를 사용자 정의할 수 있으며, 반응 과정을 실시간으로 모니터링하고 공정 조건의 신속한 선별 및 최적 반응 조건 예측을 실현하여 연구 개발 효율을 향상시킬 수 있습니다."
            },
            {
              "title": "고급 시약 정제 실험실",
              "description": "의약품 첨가제 등급 화학 제품 및 반도체 등급 전자 재료 정제에 사용됩니다. 실험실은 선진적인 정제 설비를 갖추고 있어 산, 알코올, 아민, 니트릴류 등의 화합물에 대해 증류, 막 여과 정제 기술 실험을 수행할 수 있습니다."
            },
            {
              "title": "신에너지 전해질 전용 실험실 플랫폼",
              "description": "플랫폼은 전해액 난연제 및 전해질 실험을 수행할 수 있습니다. **설비를 갖추고 있으며, 포스파젠류 난연제의 연구 개발 작업에 성공했습니다. 고객의 배터리 기술 경로에 따라 액체, 반액체 배터리 재료의 지속적인 개발이 가능합니다."
            },
            {
              "title": "생물 합성 녹색 기술 실험실 플랫폼",
              "description": "생물 합성은 상온 상압에서 진행되며, 에너지 소비가 적고 유기 용매가 필요 없으며 유독 부산물을 감소시키거나 발생시키지 않습니다. 이 플랫폼은 효소 촉매법에 기반한 생물 완충제 제품 개발, 새로운 진단 기질 및 고분자 폴리에스터 소재 개발을 진행하고 있습니다."
            },
            {
              "title": "화학 합성 실험실 플랫폼",
              "description": "화학 합성 실험실은 기존의 합성 설비 외에도 핵자기 공명(NMR), 질량 분석(MS), 고성능 액체 크로마토그래피(HPLC), 미세 채널 연속류 자동 합성 작업대, 실험실 데이터 관리 시스템(LIMS)을 갖추고 있습니다. 의약품 첨가제, 진단 기질 및 고분자 복합 소재 개발을 포함한 고객 맞춤 개발을 완료할 수 있습니다."
            }
          ],
          "platformTitle": "5대 지능형 연구 개발 플랫폼",
          "serviceIcons": [
            "생물 의학 정화제 및 구조성 화학 제품",
            "고급 체외 진단 시약 개발",
            "생물 효소 개발",
            "고급 생물 고분자 소재 개발",
            "반도체 등급 전자 화학 제품 및 신에너지 배터리 재료"
          ],
          "starProduct": "혁신 제품"
        },
        "footer": {
          "contact": {
            "phone": "전화",
            "email": "이메일"
          },
          "qrCode": {
            "scanToFollow": "스캔하여 팔로우"
          },
          "socialMedia": {
            "wechat": "위챗",
            "tiktok": "틱톡",
            "xiaohongshu": "샤오홍슈"
          },
          "copyright": "©2025 수저우 야코 테크놀로지 주식회사",
          "icp": "쑤 ICP 베이 15045967호"
        },
        "croCdmoDialog": {
          "logoAlt": "야코 로고",
          "hotline": "무료 서비스 핫라인:",
          "description": "요구 사항 정보를 남겨주시면 1영업일 이내에 연락드리겠습니다",
          "form": {
            "name": "이름",
            "namePlaceholder": "이름을 입력해 주세요",
            "contact": "연락처",
            "contactPlaceholder": "전화/휴대폰 번호/이메일을 입력해 주세요",
            "company": "회사명",
            "companyPlaceholder": "회사명을 입력해 주세요",
            "product": "제품명",
            "productPlaceholder": "제품명을 입력해 주세요",
            "cas": "CAS 번호",
            "casPlaceholder": "CAS 번호를 입력해 주세요",
            "requirement": "구매 요구",
            "requirementPlaceholder": "구매 요구 사항을 입력해 주세요",
            "attachment": "첨부 파일",
            "submit": "제출"
          },
          "upload": {
            "clickToUpload": "클릭하여 첨부 파일 업로드",
            "fileFormat": "파일 형식: jpg, pdf, doc, 파일 크기 5MB 이하",
            "fileSizeError": "파일 크기는 5MB를 초과할 수 없습니다",
            "fileTypeError": "jpg, pdf 또는 doc 형식의 파일을 업로드해 주세요",
            "uploadSuccess": "파일 업로드 성공",
            "uploadFailed": "파일 업로드 실패, 다시 시도해 주세요"
          },
          "validation": {
            "nameRequired": "이름을 입력해 주세요",
            "contactRequired": "연락처를 입력해 주세요",
            "casRequired": "CAS 번호를 입력해 주세요"
          },
          "messages": {
            "submitSuccess": "제출 성공",
            "submitFailed": "제출 실패",
            "submitFailedRetry": "제출 실패, 잠시 후 다시 시도해 주세요"
          }
        },
        "productDialog": {
          "logoAlt": "야코 로고",
          "hotline": "무료 서비스 핫라인:",
          "description": "요구 사항 정보를 남겨주시면 1영업일 이내에 연락드리겠습니다",
          "form": {
            "name": "이름",
            "namePlaceholder": "이름을 입력해 주세요",
            "contact": "연락처",
            "contactPlaceholder": "전화/휴대폰 번호/이메일을 입력해 주세요",
            "company": "회사명",
            "companyPlaceholder": "회사명을 입력해 주세요",
            "product": "제품명",
            "productPlaceholder": "제품명을 입력해 주세요",
            "cas": "CAS 번호",
            "casPlaceholder": "CAS 번호를 입력해 주세요",
            "requirement": "구매 요구",
            "requirementPlaceholder": "구매 요구 사항을 입력해 주세요",
            "submit": "제출"
          },
          "validation": {
            "nameRequired": "이름을 입력해 주세요",
            "contactRequired": "연락처를 입력해 주세요",
            "casRequired": "CAS 번호를 입력해 주세요"
          },
          "messages": {
            "submitSuccess": "제출 성공",
            "submitFailed": "제출 실패",
            "submitFailedRetry": "제출 실패, 잠시 후 다시 시도해 주세요"
          }
        },
        "serviceDialog": {
          "logoAlt": "야코 로고",
          "hotline": "무료 서비스 핫라인:",
          "description": "요구 사항 정보를 남겨주시면 1영업일 이내에 연락드리겠습니다",
          "form": {
            "name": "이름",
            "namePlaceholder": "이름을 입력해 주세요",
            "contact": "연락처",
            "contactPlaceholder": "전화/휴대폰 번호/이메일을 입력해 주세요",
            "company": "회사명",
            "companyPlaceholder": "회사명을 입력해 주세요",
            "service": "서비스명",
            "servicePlaceholder": "서비스명을 입력해 주세요",
            "requirement": "요구 상세",
            "requirementPlaceholder": "맞춤 요구 사항을 입력해 주세요",
            "submit": "제출"
          },
          "validation": {
            "nameRequired": "이름을 입력해 주세요",
            "contactRequired": "연락처를 입력해 주세요"
          },
          "messages": {
            "submitSuccess": "제출 성공",
            "submitFailed": "제출 실패",
            "submitFailedRetry": "제출 실패, 잠시 후 다시 시도해 주세요"
          }
        },
        "productDownloadDialog": {
          "logoAlt": "야코 로고",
          "title": "문서 다운로드 정보",
          "description": "문서를 다운로드하려면 아래 정보를 입력해 주세요",
          "form": {
            "companyName": "회사명",
            "companyNamePlaceholder": "회사명을 입력해 주세요",
            "email": "이메일",
            "emailPlaceholder": "이메일을 입력해 주세요",
            "mobile": "전화",
            "mobilePlaceholder": "전화번호를 입력해 주세요",
            "qq": "QQ",
            "qqPlaceholder": "QQ를 입력해 주세요 (선택)",
            "wechat": "WeChat",
            "wechatPlaceholder": "WeChat을 입력해 주세요 (선택)",
            "submit": "제출"
          },
          "validation": {
            "companyNameRequired": "회사명을 입력해 주세요",
            "emailRequired": "이메일을 입력해 주세요",
            "emailInvalid": "유효한 이메일 주소를 입력해 주세요",
            "mobileRequired": "전화번호를 입력해 주세요"
          },
          "messages": {
            "submitFailed": "제출 실패",
            "submitFailedRetry": "제출 실패, 잠시 후 다시 시도해 주세요"
          }
        },
        "purchaseDialog": {
          "logoAlt": "야코 로고",
          "title": "더 많은 브랜드 제품은 엘리멘트 쇼핑몰에서",
          "gotoStore": "쇼핑몰 바로가기",
          "storeInfo": "야코 그룹 산하 엘리멘트 쇼핑몰에서 서비스 제공"
        },
        "purchaseListDialog": {
          "logoAlt": "야코 로고",
          "productInfo": "제품 정보",
          "unitPrice": "단가(세금 포함)",
          "more": "더보기",
          "productCode": "상품 번호:",
          "itemNumber": "품번:",
          "specification": "규격:",
          "parameter": "매개변수:",
          "contactSales": "영업 담당자 문의",
          "gotoShop": "쇼핑몰 바로가기",
          "storeInfo": "야코 그룹 산하 엘리멘트 쇼핑몰에서 서비스 제공"
        },
        "resumeDialog": {
          "logoAlt": "야코",
          "upload": {
            "clickToUpload": "클릭하여 이력서 업로드",
            "fileFormat": "파일 형식: jpg, pdf, ppt, 파일 크기 5MB 이하",
            "fileSizeError": "파일 크기는 5MB를 초과할 수 없습니다",
            "fileTypeError": "jpg, pdf 또는 ppt 형식의 파일을 업로드해 주세요"
          },
          "fileInfo": {
            "removeFile": "파일 삭제"
          },
          "submit": "보내기",
          "messages": {
            "uploadSuccess": "이력서 제출 성공",
            "uploadFailed": "업로드 실패, 다시 시도해 주세요",
            "jobNotExist": "채용 공고가 존재하지 않습니다",
            "pleaseUploadFirst": "먼저 이력서를 업로드해 주세요"
          }
        },
        "goodChart": {
          "logoAlt": "야코 로고",
          "companyName": "야코 주식회사",
          "consultationPhone": "상담 전화:",
          "productService": "제품 상담 및 애프터 서비스:",
          "contactEmail": "연락 이메일:",
          "leaveMessage": "메시지 남기기"
        },
        "searchPage": {
          "pageTitle": "전체 사이트 검색",
          "searchInfo": "검색: {keyword}",
          "loading": "로딩 중...",
          "noData": "데이터 없음",
          "noNews": "관련 뉴스 없음",
          "noProducts": "관련 제품 없음",
          "productInfo": {
            "casNo": "CAS 번호:",
            "itemNumber": "품번:",
            "specification": "규격:",
            "parameter": "매개변수:",
            "price": "가격:",
            "unit": "단위:",
            "inquiry": "문의",
            "chemicalName": "화학명"
          },
          "newsInfo": {
            "typeTag": "유형 태그"
          },
          "pagination": {
            "prev": "이전",
            "next": "다음"
          }
        }
      };
